export default __webpack_public_path__ + "static/media/gallery_00.7d14ca70.jpg";